import { render, staticRenderFns } from "./SimulacionConfiguracion.vue?vue&type=template&id=78040da8&scoped=true&"
import script from "./SimulacionConfiguracion.vue?vue&type=script&lang=js&"
export * from "./SimulacionConfiguracion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78040da8",
  null
  
)

export default component.exports